module.exports = __webpack_public_path__ + "static/media/paid_search_large.893aec62.svg";